import React from "react";

function MusicpublisherIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_899_1341)">
        <mask
          id="mask0_899_1341"
          style={{ maskType: "luminance" }}
          width="16"
          height="16"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M0 0h16v16H0V0z"></path>
        </mask>
        <g mask="url(#mask0_899_1341)">
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M11 8.034c0 .555-.672.98-1.5.98-.829 0-1.5-.453-1.5-.98 0-.527.671-.98 1.5-.98.167 0 .335.024.5.064V4.712l-2.972 1.18L7 9.042c0 .555-.672.98-1.472.98-.8 0-1.5-.453-1.5-.98 0-.527.672-.98 1.5-.98.169-.028.337.022.5.035V4.513c0-.22.14-.413.351-.48l4-1.488a.497.497 0 01.649.479l-.029 5.01zM14 0H2a2 2 0 00-2 1.987v9.042c0 1.114.894 1.988 2 1.988h3v2.617a.38.38 0 00.207.338c.125.035.277.05.39-.033L9.5 12.99H14A2 2 0 0016 11V2.015C16 .901 15.134 0 14 0z"
            clipRule="evenodd"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_899_1341">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(MusicpublisherIcon);
